import { Route } from "../../parsegenerated";

export class RouteModel {
  agency_id?: string;
  route_color?: string;
  route_desc?: string;
  route_id?: string;
  route_long_name?: string;
  route_short_name?: string;
  route_text_color?: string;
}

export function toRouteModel(data: Route): RouteModel {
  return {
    agency_id: data.agency_id.get("agency_id"),
    route_color: data.route_color,
    route_desc: data.route_desc,
    route_id: data.route_id,
    route_long_name: data.route_long_name,
    route_short_name: data.route_short_name,
    route_text_color: data.route_text_color,
  };
}
